export const GRAMMAR_ITEM_TYPES = ['structured_input', 'cloze', 'reorder', 'error_fix'] as const;
